import { getRequest, postRequest } from "../apiHelpers";
import {
	searchCustomer, resetPassword, unlockAccount, changeDeviceNoti, paymentHistory, customerById, postCustomer,
	generateCode, addAgent, getAgentById, cancelAgent, editAgent, getExportCustomer, getExportAgent, postAddCustomer,
	searchUser,
	searchReqCancelAgentURL,
	approvedOrRejectCancelAgentURL,
	checkCancelAgentURL,
	uodateToAgentURL
} from "../pathApi";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const callSearchCustomer = createAsyncThunk(searchCustomer, async (body) => {
	try {
		const response = await postRequest({ url: searchCustomer, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callResetPassword = createAsyncThunk(resetPassword, async (body) => {
	try {
		const response = await postRequest({ url: resetPassword, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callUnlockAccount = createAsyncThunk(unlockAccount, async (body) => {
	try {
		const response = await postRequest({ url: unlockAccount, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callChangeDeviceNoti = createAsyncThunk(changeDeviceNoti, async (body) => {
	try {
		const response = await postRequest({ url: changeDeviceNoti, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callPaymentHistory = createAsyncThunk(paymentHistory, async (body) => {
	try {
		const response = await postRequest({ url: paymentHistory, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callCustomerById = createAsyncThunk(customerById, async (body) => {
	try {
		const response = await postRequest({ url: customerById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callPostCustomer = createAsyncThunk(postCustomer, async (body) => {
	try {
		const response = await postRequest({ url: postCustomer, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGenerateCode = createAsyncThunk(generateCode, async (body) => {
	try {
		const response = await postRequest({ url: generateCode, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callAddAgent = createAsyncThunk(addAgent, async (body) => {
	try {
		const response = await postRequest({ url: addAgent, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetAgentById = createAsyncThunk(getAgentById, async (body) => {
	try {
		const response = await postRequest({ url: getAgentById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callCancelAgent = createAsyncThunk(cancelAgent, async (body) => {
	try {
		const response = await postRequest({ url: cancelAgent, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const checkCancelAgent = createAsyncThunk(checkCancelAgentURL, async (param) => {
	try {
		const response = await getRequest({ url: checkCancelAgentURL, params: param });
		return response;
	} catch (error) {
		throw error
	}
});


export const callEditAgent = createAsyncThunk(editAgent, async (body) => {
	try {
		const response = await postRequest({ url: editAgent, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetExportCustomer = createAsyncThunk(getExportCustomer, async (body) => {
	try {
		const response = await postRequest({ url: getExportCustomer, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetExportAgent = createAsyncThunk(getExportAgent, async (body) => {
	try {
		const response = await postRequest({ url: getExportAgent, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const searchReqCancelAgent = createAsyncThunk(searchReqCancelAgentURL, async (body) => {
	try {
		const response = await postRequest({ url: searchReqCancelAgentURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const approvedOrRejectCancelAgent = createAsyncThunk(approvedOrRejectCancelAgentURL, async (body) => {
	try {
		const response = await postRequest({ url: approvedOrRejectCancelAgentURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callPostAddCustomer = createAsyncThunk(postAddCustomer, async (body) => {
	try {
		const response = await postRequest({ url: postAddCustomer, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callSearchUser = createAsyncThunk(searchUser, async (body) => {
	try {
		const response = await postRequest({ url: searchUser, data: body });
		return response;
	} catch (error) {
		throw error
	}
});
export const callUpdateToAgent = createAsyncThunk(uodateToAgentURL, async (body) => {
	try {
		const response = await postRequest({ url: uodateToAgentURL, data: body });
		return response;
	} catch (error) {
		throw error
	}
});